// Import React =>
import React from "react";

// Import Plugin =>
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { BsInstagram } from "react-icons/bs";
import { FaFacebookSquare } from "react-icons/fa";

// Import styles =>
import {
  instagramContainer,
  title,
  gridContainer,
  link,
  followUs,
  followUsLink,
  followUsIcon,
} from "./styles.module.scss";

const Instagram = () => {
  // Requêtes Bannière info
  const data = useStaticQuery(graphql`
    query {
      allInstagramContent(sort: { order: DESC, fields: timestamp }, limit: 6) {
        edges {
          node {
            caption
            permalink
            localFile {
              childImageSharp {
                gatsbyImageData(width: 600, height: 600)
              }
            }
          }
        }
      }
    }
  `);


  const posts = data.allInstagramContent.edges;

  return (
    <div className={instagramContainer}>
      <h4 className={title}>@berthe.aux.paquerettes</h4>
      <div className={gridContainer}>
        {posts.map((post) => (
          <a
            className={link}
            href={post.node.permalink}
            title={post.node.caption}
            target="_blank"
          >
            <GatsbyImage
              image={post.node.localFile.childImageSharp.gatsbyImageData}
            />
          </a>
        ))}
      </div>
      <div className={followUs}>
        <a className={followUsLink} href="https://www.instagram.com/berthe.aux.paquerettes/?hl=fr" title="Suivez nous sur Instagram">
          {" "}
          <span className={followUsIcon}><BsInstagram style={{ transform: 'translateY(3px)' }} /></span>
          Suivez nous
        </a>{" "}
        <a className={followUsLink} href="https://www.facebook.com/cindy.penezderoin" title="Suivez nous sur Facebook">
          {" "}
          <span className={followUsIcon}> <FaFacebookSquare style={{ transform: 'translateY(3px)' }} /></span>
          Suivez nous
        </a>
      </div>
    </div>
  );
};

export default Instagram;
